import { deleteEmployeeProfile } from '@api/company-policy';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';

export const useRemoveEmployeeProfileDialog = (onSuccess?: () => void) => {
  const { t } = useTranslation();

  const { mutate: removeProfile, isPending } = useMutation({
    mutationFn: deleteEmployeeProfile,
    onSuccess: () => {
      onSuccess?.();
      toast.success(t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_SUCCESS'));
    },
    onError: () => {
      toast.error(t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_ERROR'));
    },
  });

  return {
    removeProfile,
    isPending,
    t,
  };
};
